import React, {Fragment, useRef, useState} from 'react';
import {useTheme} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import {Accordion, Select, Text, PhoneInput} from '../../';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import PhoneIcon from '@material-ui/icons/Phone';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';


export default function PhoneSection(props){
  const theme=useTheme();

  function sentToPrl(contact, id){if(contact!=undefined && id!=undefined && id!=''){for(let cpn of contact.contact_phone_numbers){if(cpn.id==id && cpn.workspace_default_special_services.length>0){return true;}}} return false;}
  function getCountryObject(id, countries){if(countries!=undefined){for(let c of countries){if(c.id==id){return c;}}}}


  return(
    <Accordion
      style={{width:'calc(100% + 40px)', marginLeft:'-20px'}}
      open={(props.open_section=='phone_section')?true:false}
      onChange={()=>{props.setOpenSection((props.open_section=='phone_section')?undefined:'phone_section')}}
      content={[
        {
          title: (
            <Typography style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'0px', marginBottom:'0px'}}><span style={{color:theme.palette.primary.main}}>{"Contact phone numbers: "}</span>{<Field name="contact_phone_numbers">{(f)=><span style={{fontSize:'12px'}}>{((f.input.value==undefined)?0:f.input.value.length)}</span>}</Field>}</Typography>
          ),
          content: (<FieldArray name="contact_phone_numbers">
              {({ fields }) => (
              <div style={{width:'100%'}}>
                <Typography color="primary" style={{ width: 'calc(100% - 20px)', marginLeft: '10px', position: 'relative', marginTop: '10px', marginBottom: '20px' }}>
                </Typography>
                {fields.map((name, index) => (
                  <Fragment key={name}>
                    <hr style={{ width: '100%', marginTop: '0px', marginBottom: '0px' }} />
                    <div style={{ width: '100%' }}>
                      <Accordion
                        start_open={fields.value[index].default_open}
                        content={[
                          {
                            title: (
                              <Typography color="primary" style={{ width: '100%', position: 'relative' }}>
                                <Field name={`${name}.main`}>
                                  {(f_main) => (
                                    <Field name={`${name}.name`}>
                                      {(f_name) => (
                                        <Field name={`${name}.phone_number`}>
                                          {(f) => (
                                            <span>
                                              {f_name.input.value + ': ' + f.input.value}
                                              <span>{f_main.input.value == true ? ' (Main)' : ''}</span>
                                            </span>
                                          )}
                                        </Field>
                                      )}
                                    </Field>
                                  )}
                                </Field>
                                {(sentToPrl(props.contact, fields.value[index].id))?
                                  <Tooltip title="You can't delete a phone number which has been sent to JumpStart for scoring"><img src='/images/icons/scoring_service.png' style={{ position: 'absolute', right: '10px', top: '0px', width:'18px', cursor: 'pointer' }}/></Tooltip>
                                  :
                                  <DeleteIcon
                                  color="secondary"
                                  style={{ position: 'absolute', right: '10px', top: '0px', cursor: 'pointer' }}
                                  onClick={(e) => {
                                      if(sentToPrl(props.contact, fields.value[index].id)){setPrlPhoneBlockPopup(true);}else{fields.remove(index);
                                    }}}
                                />}
                              </Typography>
                            ),
                            content: (
                              <Grid container style={{ marginTop: '-20px' }}>
                                <Grid item xs={6} style={{ marginBottom: '10px' }}>
                                <Field name={`${name}.name`}>{(f_name)=><Field name={`${name}.call_line_type`}>{(f_t)=>{if((f_t.input.value=='' || f_t.input.value=='UNKNOWN') && f_name.input.value=='Mobile' && 1==2){f_t.input.onChange('DIRECT');} return null;}}</Field>}</Field>
                                <Select
                                  size="small"
                                  style={{ marginBottom: '10px' }}
                                  variant="outlined"
                                  title="Label"
                                  name={`${name}.name`}
                                  select_data={[
                                    { id: 'Tel', name: 'Unknown' },
                                    { id: 'Mobile', name: 'Mobile' },
                                    { id: 'Home', name: 'Home' },
                                    { id: 'Work', name: 'Work' },
                                    { id: 'Company', name:'Company'}
                                  ]}
                                />
                                </Grid>
                                <Grid item xs={6} style={{ marginBottom: '10px' }}>
                                <Field name={`${name}.call_attempts`}>{(f_call_attempts)=><Field name={`${name}.id`}>
                                    {(f_id) => <PhoneInput title="Phone" name={`${name}.phone_number`} disabled={((sentToPrl(props.contact, f_id.input.value)==true)||(f_id.input.value !== '' && f_id.input.value !== undefined && f_call_attempts.input.value!=undefined && f_call_attempts.input.value!='' && f_call_attempts.input.value>0))}/>}
                                  </Field>}</Field>
                                </Grid>
                                <Grid item xs={6}>
                                  <Select
                                    size="small"
                                    style={{ marginBottom: '10px' }}
                                    variant="outlined"
                                    title="Call line type"
                                    name={`${name}.call_line_type`}
                                    enum='call_line_type'
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                    <Select
                                      size="small"
                                      style={{ marginBottom: '10px' }}
                                      variant="outlined"
                                      title="Call line status"
                                      name={`${name}.call_line_status`}
                                      enum="call_line_status"
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                  <div style={{ marginLeft: '10px' }}>
                                    <FormControlLabel
                                      control={
                                        <Field name={`${name}.main`}>
                                          {(f) => <Checkbox checked={f.input.value} onClick={(e)=>{f.input.onChange(!f.input.value)}} name={`${name}.main`} />}
                                        </Field>
                                      }
                                      label="Main phone number"
                                    />
                                  </div>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                  <Text
                                    title="Call line note"
                                    name={`${name}.call_line_note`}
                                    multiline
                                    rows={2}
                                    variant="outlined"
                                    style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px' }}
                                  />
                                </Grid>
                              </Grid>
                            ),
                          },
                        ]}
                      />
                    </div>
                  </Fragment>
                ))}
                <Field name={'country_id'}>{(f_country_id)=><div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'20px'}}><Button color="secondary" variant="contained" style={{cursor:'pointer'}} onClick={() => {
                  if(fields.value.length<5){
                  let country=getCountryObject(f_country_id.input.value, props.countries); if(country==undefined){country=getCountryObject(props.company.country_id, props.countries);} if(country==undefined){country=getCountryObject(props.workspace.country_id, props.countries);}
                  fields.push({name: 'Tel', phone_number:(country==undefined)?'+':'+'+JSON.parse(country.call_code)[0], call_line_status: 'NOT_VERIFIED', main: false, default_open:true});
                }}}>Add phone number</Button></div>}</Field>
              </div>
              )}
              </FieldArray>
            )}]}/>
  )
}
